<template>
  <div class="t-day" :class="{'t-day_active': active, 't-day_small': mobileCalendar, '_today': today}">
    <div class="t-day__container">
      <p class="t-day__date">{{ day }}</p>
      <p class="t-day__current" v-if="active && !mobileCalendar && lesson_type === 3">{{ titleStream }}</p>
    </div>

    <template v-if="active && !mobileCalendar">
      <p class="t-day__name">{{ title }}</p>
      <p class="t-day__time">{{ time }}</p>
    </template>
    <div class="t-day__buttons" v-if="(dayDate >= new Date())">
      <button @click.prevent.stop="Add(day)">
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C8 0.449219 7.55225 0 7 0C6.44775 0 6 0.449219 6 1V6H1C0.447754 6 0 6.44922 0 7C0 7.55078 0.447754 8 1 8H6V13C6 13.5508 6.44775 14 7 14C7.55225 14 8 13.5508 8 13V8H13C13.5522 8 14 7.55078 14 7C14 6.44922 13.5522 6 13 6H8V1Z" fill="white"/>
        </svg>
      </button>
      <button v-if="active && edit && !mobileCalendar" @click.prevent.stop="Edit(day)">
        <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1C2 1.55228 1.55228 2 1 2C0.447715 2 0 1.55228 0 1ZM6 1C6 0.447715 6.44772 0 7 0C7.55228 0 8 0.447715 8 1C8 1.55228 7.55228 2 7 2C6.44772 2 6 1.55228 6 1ZM14 1C14 0.447715 13.5523 0 13 0C12.4477 0 12 0.447715 12 1C12 1.55228 12.4477 2 13 2C13.5523 2 14 1.55228 14 1Z" fill="white"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
    import {store} from '../../../store'

    import {mapGetters} from 'vuex';
    import {mapActions} from 'vuex';

    export  default {
        props: ['day', 'lessons', 'lesson_type'],
        data(){
            return{
                title: store.getters['calendar/calendarText'].lesson,
                titleStream: '',
                time: '',
                id: null,

                edit: false,
            }
        },
        computed: {
            ...mapGetters(['mobileCalendar']),
            ...mapGetters('calendar', ['date_active', 'calendarText']),
            ...mapGetters('coursesList', ['streamsMy', 'streamsEntries']),
            dayDate(){
                return new Date(this.date_active.getFullYear(),this.date_active.getMonth() , this.day+1 )
            },
            active(){
                this.title = this.calendarText.lesson;

                this.edit = false;
                this.titleStream = '';
                this.time = '';

                let lessons_count = 0;
                let lessons_count_lesson = 0;


                let date = this.date_active.getFullYear() + '.' + (this.date_active.getMonth() + 1) + '.' + this.day;

                let today = new Date(),
                    today_text = today.getFullYear() + '.' + (today.getMonth() + 1) + '.' + today.getDate();

                this.today = today_text === date;
                let streamInDayList = {};
                // console.log(this.lessons);
                for(let i = 0; i < this.lessons.length; i++){
                    for(let j = 0; j < this.lessons[i].date_time.length; j++){
                        let date2 = new Date(this.lessons[i].date_time[j].date);
                        let date2_text = date2.getFullYear() + '.' + (date2.getMonth() + 1) + '.' + date2.getDate();

                        if(date2_text === date) {
                            // console.log(this.lessons[i].date_time[j] )
                            if(this.lesson_type === 3){
                                this.title = (i + 1) + ' ' + this.calendarText.lesson;
                                // this.titleStream = (j + 1) + ' ' + this.calendarText.stream;
                                // this.titleStream += (this.lessons[i].date_time[j].streamId || this.lessons[i].date_time[j].localStreamIndex) + ', '      
                                // streamInDayList.push( this.lessons[i].date_time[j].streamId || this.lessons[i].date_time[j].localStreamIndex );
                                // console.log(this.lessons[i].date_time[j])
                                streamInDayList[ this.lessons[i].date_time[j].streamId || this.lessons[i].date_time[j].localStreamIndex ]++;
                            }

                            // console.log( lessons_count )
                            lessons_count++;

                            let time_start = [];
                            time_start.push(date2.getHours() < 10 ? '0' + date2.getHours() : date2.getHours());
                            time_start.push(date2.getMinutes() < 10 ? '0' + date2.getMinutes() : date2.getMinutes());

                            this.time += time_start.join(':') + ', ';

                            if(this.$route.name === 'courses_edit'){
                                if(this.lessons[i].date_time[j].update){
                                    this.edit = true;
                                }
                            } else{
                                this.edit = true;
                            }
                        }
                    }
                }

                // console.log(date)
                // console.log('lessons_count', lessons_count)
                this.time = this.time.substring(0, this.time.length - 2);
                lessons_count_lesson = lessons_count;

                if(lessons_count === 0 || this.lesson_type === 3){
                    for(let s = 0; s < this.streamsMy.length; s++){
                        let streams = this.streamsMy[s];

                        for(let l = 0; l < streams.lessons.length; l++){
                            let lesson = streams.lessons[l];

                            let day = new Date(lesson.date_time);
                            let date_2 = day.getFullYear() + '.' + (day.getMonth() + 1) + '.' + day.getDate();

                            if(date_2 === date){
                                lessons_count++;
                            }
                        }
                    }
                    for(let s = 0; s < this.streamsEntries.length; s++){
                        let streams = this.streamsEntries[s];

                        for(let l = 0; l < streams.lessons.length; l++){
                            let lesson = streams.lessons[l];

                            let day = new Date(lesson.date_time);
                            let date_2 = day.getFullYear() + '.' + (day.getMonth() + 1) + '.' + day.getDate();

                            if(date_2 === date){
                                lessons_count++;
                            }
                        }
                    }

                    if (lessons_count === 0 || this.lesson_type !== 3) {
                        this.title = lessons_count + ' ' + this.declOfNum(lessons_count, this.calendarText.eventArr);
                    }
                }

                if (this.lesson_type === 3) {
                    // console.log(streamInDayList) 
                    if (Object.keys(streamInDayList).length > 0)
                        this.titleStream = Object.keys(streamInDayList).join(', ') + ' ' + this.calendarText.stream;

                    let diff = lessons_count - lessons_count_lesson;

                    // console.log('lessons_count', lessons_count_lesson)

                    // console.log('diff', lessons_count - lessons_count_lesson)

                    if (lessons_count > 1 || diff > 0) {
                        this.title = lessons_count + ' ' + this.declOfNum(lessons_count, this.calendarText.eventArr);
                        // this.titleStream = '';
                        // this.time = '';
                    }
                }
                return lessons_count > 0
            }
        },
        methods: {
            ...mapActions('calendar', ['SetOpenDay', 'OpenAddForm', 'OpenEditForm']),
            declOfNum(n, titles) {
                return titles[(n % 10 === 1 && n % 100 !== 11) ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2]
            },
            Add(day){
                this.SetOpenDay(day);
                this.OpenAddForm();
            },
            Edit(day){
                this.SetOpenDay(day);
                this.OpenEditForm();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/vue_components/Calendar/Create/Day.vue